import React from 'react';
import { Box, Container, Grid, Typography, Link } from '@mui/material';

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#f8f9fa',
                borderTop: '1px solid #e0e0e0',
                mt: 'auto',
                py: 3
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="space-between">
                    {/* Student Link Logo et Description */}
                    <Grid item xs={12} md={3}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <img
                                src="/assets/images/logo.png"
                                alt="Student Link Logo"
                                style={{ height: 40, marginRight: 15, borderRadius: '20%' }}
                            />
                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black' }}>
                                Student Link
                            </Typography>
                        </Box>
                        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 300 }}>
                            Ton job, ton CV, ta vidéo — le tout en quelques minutes.
                        </Typography>
                    </Grid>

                    {/* Navigation */}
                    <Grid item xs={12} md={2}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                            Plateformes
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link href="/entreprises" color="inherit">Entreprises</Link>
                            <Link href="/ecoles" color="inherit">Écoles</Link>
                            <Link href="/etudiants" color="inherit">Étudiants</Link>
                            <Link href="/associations" color="inherit">Associations</Link>
                        </Box>
                    </Grid>

                    {/* Ressources */}
                    <Grid item xs={12} md={2}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                            Ressources
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link href="/a-propos" color="inherit">À propos</Link>
                            <Link href="/contact" color="inherit">Nous contacter</Link>
                        </Box>
                    </Grid>

                    {/* Légal */}
                    <Grid item xs={12} md={2}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                            Légal
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                            <Link href="https://studentlink.fr/politique-de-confidentialit%C3%A9-et-cgu.html" target="_blank" rel="noopener noreferrer" color="inherit" sx={{ textDecoration: 'none', '&:hover': { color: '#0075FF' } }}>
                                CGU & Politique de confidentialité
                            </Link>
                            <Link href="https://studentlink.fr/mentions-l%C3%A9gales.html" target="_blank" rel="noopener noreferrer" color="inherit" sx={{ textDecoration: 'none', '&:hover': { color: '#0075FF' } }}>
                                Mentions légales
                            </Link>
                        </Box>
                    </Grid>

                    {/* Réseaux sociaux */}
                    <Grid item xs={12} md={3}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
                            Suivez-nous
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Link href="https://www.instagram.com/studentlink.app/" target="_blank" rel="noopener noreferrer" sx={{ '&:hover': { opacity: 0.7 } }}>
                                <Box
                                    component="img"
                                    src="https://cdn-icons-png.flaticon.com/512/174/174855.png"
                                    alt="Instagram"
                                    sx={{ width: 24, height: 24 }}
                                />
                            </Link>
                            <Link href="https://www.linkedin.com/company/student-link-app/?viewAsMember=true" target="_blank" rel="noopener noreferrer" sx={{ '&:hover': { opacity: 0.7 } }}>
                                <Box
                                    component="img"
                                    src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                                    alt="LinkedIn"
                                    sx={{ width: 24, height: 24 }}
                                />
                            </Link>
                            <Link href="https://www.tiktok.com/@studentlink.app" target="_blank" rel="noopener noreferrer" sx={{ '&:hover': { opacity: 0.7 } }}>
                                <Box
                                    component="img"
                                    src="https://cdn-icons-png.flaticon.com/512/3046/3046121.png"
                                    alt="TikTok"
                                    sx={{ width: 24, height: 24 }}
                                />
                            </Link>
                        </Box>
                    </Grid>

                    {/* Copyright */}
                    <Grid item xs={12}>
                        <Box sx={{ borderTop: '1px solid #e0e0e0', pt: 2, mt: 2 }}>
                            <Typography variant="body2" color="text.secondary" align="center">
                                © 2025 Student Link. Tous droits réservés.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}